import { httpDelete, httpDelete_New, httpGet, httpGetFile, httpPost } from './api.service';
import { PaginatedResult } from '../types/PaginatedResult';
import { Policy } from '../types/Policy';
import { SingleResult } from '../types/SingleResult';

const getPolicies = async (params: any): Promise<PaginatedResult<Policy>> => await httpGet(`api/auth/policy`, params);

const getPolicy = async (policyId: string): Promise<SingleResult<Policy>> => await httpGet(`api/auth/policy/${policyId}`);

const savePolicy = async (name: string): Promise<SingleResult<Policy>> => await httpPost(`api/auth/policy/`, name);

const deletePolicy = async (id: string): Promise<void> => await httpDelete_New(`api/auth/policy/${id}`);

const addPermissionToPolicy = async (policyId: string, permissionId: any): Promise<SingleResult<Policy>> =>
  await httpPost(`api/auth/policy/${policyId}/permission/${permissionId}`);

const removePermissionFromPolicy = async (policyId: string, permissionId: any): Promise<SingleResult<Policy>> =>
  await httpDelete(`api/auth/policy/${policyId}/permission/${permissionId}`);

const exportPolicies = async (params: any): Promise<void> => await httpGetFile(`api/auth/policy/export`, params);

export { getPolicies, getPolicy, savePolicy, deletePolicy, addPermissionToPolicy, removePermissionFromPolicy, exportPolicies };
